import React from 'react'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import Header from './components/Header/Header.jsx'
import Main from './components/Main/Main.jsx'
import Footer from './components/Footer/Footer.jsx'
import { CssBaseline, makeStyles } from '@material-ui/core'
import AppTheme from './contexts/AppTheme.jsx'
import { ProductsProvider } from './contexts/ProductsContext.jsx'
import { CartProvider } from './contexts/CartContext.jsx'
import { UserProvider } from './contexts/UserContext.jsx'
import './index.css'

const App = () => {
  const useStyles = makeStyles((theme) => ({
    app: {
      position: 'relative'
    }
  }))

  const classes = useStyles()

  return (
    <div className={classes.app}>
      <Router>
        <Switch>
          <ProductsProvider>
            <CartProvider>
              <UserProvider>
                <AppTheme>
                  <CssBaseline />
                  <Header />
                  <Main />
                  <Footer />
                </AppTheme>
              </UserProvider>
            </CartProvider>
          </ProductsProvider>
        </Switch>
      </Router>
    </div>
  )
}

export default App
